/* eslint-disable no-unused-vars */
import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Footer from "../Footer/Footer";
import { getUser } from "../Utility/getUser"; // Import the getUser function

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [car, setCar] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCar = async () => {
      try {
        const response = await fetch(`https://panel.masit.net/api/view.php?table=items&items_id=${id}`);
        const data = await response.json();
        console.log("Fetched car data:", data); // Debugging: Log the fetched data
        if (data.length > 0) {
          setCar(data[0]); // Assuming the first item in the array is the car we want
        }
      } catch (error) {
        console.error("Error fetching car data:", error);
      }
    };

    fetchCar();
  }, [id]);

  const addToCart = async () => {
    const user = getUser(); // Get the user information from local storage

    if (!user) {
              // Display a Tailwind CSS alert box
              const alertBox = document.createElement('div');
              alertBox.className = 'fixed bottom-4 left-1/2 transform -translate-x-1/2 bg-red-500 text-white p-4 rounded shadow-lg';
              alertBox.textContent = 'Login or signup First!';
              document.body.appendChild(alertBox);
            
              setTimeout(() => {
                alertBox.remove();
              }, 3000);
              
      navigate('/signin'); // Redirect to the login page

    }

    try {
      const response = await fetch('https://panel.masit.net/api/product/create.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          table: 'cart',
          data: {
            cart_usersid: user.users_id, // Use the user ID from the getUser function
            cart_itemsid: car.items_id.toString(),
          },
        }),
      });
      const data1 = await response.json();
      if (data1.message.includes("erfolgreich")) {
        console.log("Item added to cart successfully");
        navigate('/cart'); // Redirect to the checkout page
        window.location.reload(); // Refresh the page
      } else {
        console.error("Failed to add item to cart:", data1.message);
      }
    } catch (error) {
      console.error("Error adding to cart:", error);
    }
  };

  if (!car) {
    return <div>Loading...</div>;
  }

  return (
    <div className="product-detail bg-white dark:bg-black dark:text-white text-black">
      <div className="container mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="lg:grid lg:grid-cols-2 lg:gap-x-8">
          <div className="lg:max-w-lg lg:self-end">
            <div className="aspect-w-4 aspect-h-3 rounded-lg overflow-hidden">
              {car.items_image ? (
                <img
                  src={car.items_image}
                  alt={car.items_name}
                  className="w-full h-full object-center object-cover"
                />
              ) : (
                <div className="w-full h-full flex items-center justify-center bg-gray-200 dark:bg-gray-700">
                  <span className="text-gray-500 dark:text-gray-300">No Image Available</span>
                </div>
              )}
            </div>
          </div>
          <div className="mt-10 lg:mt-0 lg:self-center">
            <div className="max-w-lg">
              <h1 className="text-3xl font-extrabold tracking-tight text-gray-900 dark:text-white sm:text-4xl">
                {car.items_name}
              </h1>
              <p className="mt-4 text-2xl text-gray-900 dark:text-white">
                {car.items_desc}
              </p>
              <p className="mt-4 text-2xl text-gray-900 dark:text-white">
                €{car.items_price}/day
              </p>
              <p className="mt-4 text-gray-500 dark:text-gray-300">
                {car.aosDelay} KM
              </p>
              <div className="mt-6">
                <button
                  onClick={addToCart}
                  className="w-full bg-red-600 hover:bg-red-500 border border-transparent rounded-md py-3 px-8 flex items-center justify-center text-base font-medium text-white hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
                >
                  Add to Cart
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ProductDetail;